/**
 * useArchivedChannels — `GET /api/channels/archived`.
 *
 * Manage-channels gated. Drives the admin-only `<ArchivedChannelsModal>`.
 * Cache key `['archived-channels']`. Caller passes `enabled` through so
 * non-admins never trigger the request (the BE would 403 anyway, but the
 * gate keeps the network surface clean).
 */

import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/api/client'
import type { ChatArchivedChannel } from '@/api/types-bridge'

export const ARCHIVED_CHANNELS_QUERY_KEY = ['archived-channels'] as const

export function useArchivedChannels(enabled = true) {
  return useQuery({
    queryKey: ARCHIVED_CHANNELS_QUERY_KEY,
    queryFn: async () => {
      const res = await apiClient<{ data: ChatArchivedChannel[] }>('/api/channels/archived')
      return res.data
    },
    enabled,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
